import { DrawerNavigationProp } from "@react-navigation/drawer";
import { MainStackParamList } from "../../../navigation/Navigation.types";
import { Button, Div, Label } from "@grassrootly/rn-core";
import useNonGroupMemberCTA from "./useNonGroupMemberCTA";

export type NonGroupMemberCTAProps = {
  navigation: DrawerNavigationProp<MainStackParamList>;
};

export default function NonGroupMemberCTA(props: NonGroupMemberCTAProps) {
  const { handleCreateGroup, handleJoinGroup } = useNonGroupMemberCTA(props);

  return (
    <>
      <Div classNames={["flex1", "alignContentCenter", "mt-{30}"]}>
        <Div classNames={["dFlex", "flexColumn", "gap24", "alignItemsCenter", "textCenter"]}>
          <Label type="l1Bold">
            Your next match is just a tap away! Join team or create a team and unlock stats, rankings and awards as
            you play!
          </Label>
          <Div classNames={["flexRow", "alignItemsCenter", "justifyContentCenter", "gap16"]}>
            <Button
              title="Create Team"
              right={{ name: "add" }}
              onPress={handleCreateGroup}
              classNames={["minH-{24}", "pb-{9}", "pt-{9}"]}
            />
            <Button
              title="Join Team"
              classNames={["btn", "btnOutlinePrimary", "minH-{23}", "pv8"]}
              right={{ name: "group_add" }}
              onPress={handleJoinGroup}
            />
          </Div>
        </Div>
      </Div>
    </>
  );
}
